function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.79 43.21"
}, props), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: "1.36",
  d: "M17.47 1.76l13.5 8.42L14.33 36.9.82 28.48z"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.76",
  d: "M1.55 42.33l12.82-5.54L.88 28.38l.67 13.95z"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: "1.76",
  d: "M21.45 4.92L5.18 31.02M27.05 7.51l-16.27 26.1"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M26.5 2.24c-4-2.51-8.07-3.3-9.93-.32L31.16 11c1.84-3-.63-6.25-4.66-8.76zM1 35.7l.33 6.98 6.42-2.77L1 35.7z"
})));